import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Contact from '../components/contact';
import Footer from '../components/footer';
function ContactPage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <Contact />
        <Footer />
      </div>
    );
  }

 export default ContactPage; 
  
  